// removed by extract-text-webpack-plugin
module.exports = {"portfolioCard":"_3l-YvKJiEBef_aoPrz84Ew","header":"_2qQhGT8g2ZXvU9DOdoBteH","subHeader":"_1J80vlIL554aYX6DzAVxSa","description":"gimVogQ4OfkpOGOwVpypt"};


/*****************
 ** WEBPACK FOOTER
 ** ../components/PortfolioCard.module.scss
 ** module id = 1753
 ** module chunks = 0
 **/